import { render, staticRenderFns } from "./任务添加栏.vue?vue&type=template&id=5ffe813a&scoped=true&"
import script from "./任务添加栏.vue?vue&type=script&lang=js&"
export * from "./任务添加栏.vue?vue&type=script&lang=js&"
import style0 from "./任务添加栏.vue?vue&type=style&index=0&id=5ffe813a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe813a",
  null
  
)

export default component.exports